export default "__VITE_ASSET__6G9nzWIN__"